import React, {ReactNode, useContext, useEffect, useState} from "react";
import {generatePath, useNavigate, useParams} from "react-router";
import {routePaths} from "../router/routes";

export interface TabsState {
  selectedTab: number,
  selectTab: (tabIndex: number) => void
}

export const TabsContext = React.createContext<TabsState | undefined>(undefined);

export function useTabs(): TabsState {
  const tabsContext = useContext(TabsContext);
  if (!tabsContext) {
    throw new Error('useTabs must be used within the TabsContext.Provider');
  }
  return tabsContext;
}

export function TabsProvider(props: {
  children?: ReactNode;
}) {
  const params = useParams();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (params.selection) {
      setSelectedTab(Number.parseInt(params.selection as string));
    } else {
      selectTab(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[params.selection]);

  function selectTab(tabIndex: number) {
    const path = generatePath(routePaths.userAndDataWithSelection, {selection: tabIndex.toString()})
    navigate(path);
  }

  return (
    <TabsContext.Provider value={{selectedTab: selectedTab, selectTab: selectTab}}>
      {props.children}
    </TabsContext.Provider>
  )
}
